// 仪表盘 — M8 已切真后端
// 当前状态：articles 表已有 311 行（mp_article_list scraper 已跑），所以 topArticles 是真的；
// 阅读 / 粉丝 / 健康度等 KPI 在对应 scraper（M6.5+）上线前都会是 0。
import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'

export interface KPISnapshot {
  healthScore: number
  healthDelta: number
  cumulateUser: number
  cumulateDelta: number
  weeklyRead: number
  weeklyReadDelta: number
  weeklyComment: number
  weeklyCommentDelta: number
}

export interface ScrapeStatus {
  status: 'success' | 'warning' | 'danger' | 'idle'
  lastRunAt: number
  message?: string
  queueTasks: number
  dataGapDays: number
}

export interface TrendPoint {
  date: string
  value: number
}

export interface TopArticle {
  id: number
  title: string
  read: number
}

// ===================== 4 块新增汇总 (Task 18) =====================

export interface InterfaceSummary {
  interfaceName: string
  callCount: number
  failCount: number
  avgCostMs: number
}

export interface MenuSummary {
  menuId: string
  menuName: string
  clickCount: number
  clickUser: number
}

export interface MessageByType {
  msgType: string
  count: number
}

export interface MessageSummary {
  total: number
  byType: MessageByType[]
}

export interface CommentsSummary {
  total: number
  elected: number
}

export interface DashboardData {
  kpi: KPISnapshot
  fanTrend7d: TrendPoint[]
  fanTrend30d: TrendPoint[]
  readTrend30d: TrendPoint[]
  scrape: ScrapeStatus
  topArticles: TopArticle[]
  interfaces: InterfaceSummary[]
  menus: MenuSummary[]
  messages: MessageSummary
  comments: CommentsSummary
}

export function useOverview() {
  return useQuery({
    queryKey: ['dashboard', 'overview'],
    queryFn: () => get<DashboardData>('/dashboard/overview'),
  })
}

export function useFanTrend(days: 7 | 30 | 90 = 7) {
  return useQuery({
    queryKey: ['dashboard', 'fan-trend', days],
    queryFn: async () => {
      // 7/30 直接走 overview 复用一次 HTTP；90 走 /dashboard/trend 单独请求
      if (days === 7 || days === 30) {
        const d = await get<DashboardData>('/dashboard/overview')
        return days === 7 ? d.fanTrend7d : d.fanTrend30d
      }
      return get<TrendPoint[]>(`/dashboard/trend?metric=fans&days=${days}`)
    },
  })
}

export function useReadTrend(days: 30 | 90 = 30) {
  return useQuery({
    queryKey: ['dashboard', 'read-trend', days],
    queryFn: async () => {
      // 30d 走 overview 复用；90d 单独 /dashboard/trend 请求
      if (days === 30) {
        const d = await get<DashboardData>('/dashboard/overview')
        return d.readTrend30d
      }
      return get<TrendPoint[]>(`/dashboard/trend?metric=read&days=${days}`)
    },
  })
}

export function useScrapeStatus() {
  return useQuery({
    queryKey: ['dashboard', 'scrape-status'],
    queryFn: () => get<ScrapeStatus>('/scrape/status'),
    refetchInterval: 60_000,
  })
}
